import { formatMeeting } from '@/app/explore/coursePresentation';
import type { ScheduledCourse } from '@/app/types/interfaces';
import type { CoursePageContext } from './types';

const instructorNames = (course: ScheduledCourse) => course.instructors
  .map((entry) => (typeof entry === 'string' ? entry : entry.name))
  .filter((name) => name && !/^tba$/i.test(name));

/** The student's own section of a course, as a schedule-bearing page knows it. */
export function scheduledSectionContext(
  course: ScheduledCourse,
  label: string,
  extra: CoursePageContext['facts'] = [],
  note?: CoursePageContext['note'],
): CoursePageContext {
  const instructors = instructorNames(course);
  const meetings = course.meetingTimes?.length ? course.meetingTimes.map(formatMeeting) : [];
  return {
    label,
    facts: [
      ...extra,
      { label: 'Section', value: `${course.section} · index ${course.id}` },
      ...(meetings.length ? [{ label: meetings.length > 1 ? 'Meetings' : 'Meeting', value: meetings.join('; ') }] : []),
      ...(instructors.length ? [{ label: instructors.length > 1 ? 'Instructors' : 'Instructor', value: instructors.join(', ') }] : []),
      ...(typeof course.isOpen === 'boolean' ? [{ label: 'Seats', value: course.isOpen ? 'Open in the latest snapshot' : 'Closed in the latest snapshot' }] : []),
    ],
    note,
  };
}
